"use strict";

const ToDoConfig = function () {
  const getToDoConfigBySubject = function () {
    return {
      maintenanceNeeded: {
        apiSubjectName: "maintenance needed",
        displayName: "Functional Repairs",
        popupHighlightSelector: ".tr-score",
        numberBubbleClass: "asset-poor",
        canAccessCallback: BmpFcsToDoController.canAssess,
        listTemplate: "list/toDoListTables/maintenanceNeeded.njk",
        getSortersDictCallback: BmpFcsToDoController.getBmpFcsSortersDict,
      },
      assessmentDue: {
        apiSubjectName: "assessment due",
        displayName: "Functional Assessments",
        popupHighlightSelector: ".js-popup-assessment-button",
        numberBubbleClass: "asset-due",
        canAccessCallback: BmpFcsToDoController.canAssess,
        listTemplate: "list/toDoListTables/assessmentDue.njk",
        getSortersDictCallback: BmpFcsToDoController.getBmpFcsSortersDict,
      },
      inventoryIncomplete: {
        apiSubjectName: "inventory incomplete",
        displayName: "Missing Information",
        popupHighlightSelector: ".tr-inventory",
        numberBubbleClass: "asset-incomplete",
        canAccessCallback: BmpFcsToDoController.canCreate,
        listTemplate: "list/toDoListTables/inventoryIncomplete.njk",
        getSortersDictCallback: BmpFcsToDoController.getBmpFcsSortersDict,
      },
      routineSiteVisit: {
        apiSubjectName: "routine-site-visit",
        databaseName: "routine_site_visit",
        displayName: "Routine Inspection",
        popupHighlightSelector: ".js-add-bmpfcs-routine-inspection",
        numberBubbleClass: "asset-due",
        canAccessCallback: BmpFcsToDoController.canInspect,
        prepareDataCallback: BmpFcsToDoController.organizeRoutineSiteVisitData,
        defaultSort: "dueDateIso",
        listTemplate: "list/toDoListTables/routineSiteVisit.njk",
        getSortersDictCallback: BmpFcsToDoController.getCatchBasinSortersDict,
        prioritizeModule: UserPermissions.getPermission("can_prioritize_tasks")
          ? ToDoPrioritizeController
          : null,
      },
      routineRepair: {
        apiSubjectName: "routine-repair",
        databaseName: "routine_repair",
        displayName: "Routine Maintenance",
        popupHighlightSelector: ".js-add-bmpfcs-routine-repair",
        numberBubbleClass: "asset-poor",
        canAccessCallback: BmpFcsToDoController.canInspect,
        prepareDataCallback: BmpFcsToDoController.organizeRepairData,
        getFilterTemplateDataCallback: MuniBmpFilters.addTodoProps,
        defaultSort: "dueDateIso",
        listTemplate: "list/toDoListTables/routineRepair.njk",
        getSortersDictCallback: BmpFcsToDoController.getCatchBasinSortersDict,
      },
      routineSiteVisitBmp: {
        apiSubjectName: "sbmp-site-visit",
        displayName: "Routine Inspection",
        databaseName: "routine_site_visit",
        popupHighlightSelector: ".js-popup-routine-inspection-maintenance",
        numberBubbleClass: "asset-due",
        canAccessCallback: BmpFcsToDoController.canInspect,
        prepareDataCallback: BmpFcsToDoController.organizeRoutineSiteVisitBmpData,
        listTemplate: "list/toDoListTables/routineSiteVisitBmp.njk",
        defaultSort: "dueDateIso",
        getSortersDictCallback: BmpFcsToDoController.getMuniBmpSortersDict,
      },
      routineRepairBmp: {
        apiSubjectName: "sbmp-routine-repair",
        displayName: "Routine Maintenance",
        databaseName: "routine_repair",
        popupHighlightSelector: ".js-popup-routine-inspection-maintenance",
        numberBubbleClass: "asset-poor",
        canAccessCallback: BmpFcsToDoController.canInspect,
        prepareDataCallback: BmpFcsToDoController.organizeRoutineRepairBmpData,
        listTemplate: "list/toDoListTables/routineRepairBmp.njk",
        defaultSort: "dueDateIso",
        getSortersDictCallback: BmpFcsToDoController.getMuniBmpSortersDict,
      },
      lidRoutineSiteVisitBmp: {
        apiSubjectName: "sbmp-site-visit",
        displayName: "Routine Inspection",
        databaseName: "routine_site_visit",
        popupHighlightSelector: ".js-popup-routine-inspection-maintenance",
        numberBubbleClass: "asset-due",
        canAccessCallback: BmpFcsToDoController.canInspect,
        prepareDataCallback: BmpFcsToDoController.organizeRoutineSiteVisitLidBmpData,
        listTemplate: "list/toDoListTables/lidRoutineSiteVisitBmp.njk",
        defaultSort: "dueDateIso",
        getSortersDictCallback: BmpFcsToDoController.getLidBmpSortersDict,
      },
      lidReInspectionBmp: {
        apiSubjectName: "sbmp-routine-repair",
        displayName: "Re-Inspection",
        databaseName: "routine_repair",
        popupHighlightSelector: ".js-popup-routine-inspection-maintenance",
        numberBubbleClass: "asset-poor",
        canAccessCallback: BmpFcsToDoController.canInspect,
        prepareDataCallback: BmpFcsToDoController.organizeRoutineRepairLidBmpData,
        listTemplate: "list/toDoListTables/lidReInspectionBmp.njk",
        defaultSort: "dueDateIso",
        getSortersDictCallback: BmpFcsToDoController.getLidBmpSortersDict,
      },
      catchBasinInventoryIncomplete: {
        apiSubjectName: "catch-basin-inventory-incomplete",
        databaseName: "catch_basin_inventory_incomplete",
        displayName: "Missing Information",
        popupHighlightSelector: ".tr-inventory",
        numberBubbleClass: "asset-incomplete",
        prepareDataCallback: BmpFcsToDoController.organizeCatchBasinInventoryIncompleteData,
        canAccessCallback: BmpFcsToDoController.possiblyEditBmp,
        defaultSort: "bmpName",
        listTemplate: "list/toDoListTables/catchBasinInventoryIncomplete.njk",
        getSortersDictCallback: BmpFcsToDoController.getCatchBasinSortersDict,
      },
      incidentNew: {
        apiSubjectName: "incident-new",
        databaseName: "incident_new",
        displayName: "New Requests",
        popupHighlightSelector: ".new-incident-investigation",
        numberBubbleClass: "asset-due",
        prepareDataCallback: IncidentToDoList.organizeNew,
        canAccessCallback: IncidentInvestigationConstants.canAccessIncidentInvestigations,
        filterTemplate: "modals/toDoFilters/incidentNewFiltersModal.njk",
        getFilterTemplateDataCallback: IncidentInventoryConstants.addIncidentToDoFilterOptions,
        listTemplate: "list/incidentNewToDoList.njk",
        defaultSort: "requestedDate",
        loadListenersCallback: IncidentToDoList.loadInvestigationListeners,
        getSortersDictCallback: IncidentToDoList.getSortersDict,
      },
      incidentOpen: {
        apiSubjectName: "incident-open",
        databaseName: "incident_open",
        displayName: "Open Investigations",
        popupHighlightSelector: ".new-incident-investigation",
        numberBubbleClass: "asset-poor",
        prepareDataCallback: IncidentToDoList.organizeIncidentOpen,
        canAccessCallback: IncidentInvestigationConstants.canAccessIncidentInvestigations,
        filterTemplate: "modals/toDoFilters/incidentOpenFiltersModal.njk",
        getFilterTemplateDataCallback: IncidentInventoryConstants.addIncidentToDoFilterOptions,
        listTemplate: "list/incidentOpenToDoList.njk",
        defaultSort: "followUpDate",
        loadListenersCallback: IncidentToDoList.loadInvestigationListeners,
        getSortersDictCallback: IncidentToDoList.getSortersDict,
      },
      incidentReinvestigation: {
        apiSubjectName: "incident-reinvestigation",
        databaseName: "incident_reinvestigation",
        displayName: "Re-Investigations",
        popupHighlightSelector: ".new-incident-investigation",
        numberBubbleClass: "asset-poor",
        prepareDataCallback: IncidentToDoList.organizeReinvestigation,
        canAccessCallback: IncidentInvestigationConstants.canAccessIncidentInvestigations,
        listTemplate: "list/toDoListTables/incidentReinvestigation.njk",
        defaultSort: "followUpDate",
        loadListenersCallback: IncidentToDoList.loadInvestigationListeners,
        getSortersDictCallback: IncidentToDoList.getSortersDict,
      },
      incidentMaintenanceResponse: {
        apiSubjectName: "incident-maintenance-response",
        databaseName: "incident_maintenance_response",
        displayName: "Awaiting Maintenance Responses",
        popupHighlightSelector: ".new-incident-investigation",
        numberBubbleClass: "asset-poor",
        prepareDataCallback: IncidentToDoList.organizeMaintenanceResponse,
        canAccessCallback: IncidentInvestigationConstants.canAccessIncidentInvestigations,
        listTemplate: "list/toDoListTables/incidentMaintenanceResponse.njk",
        defaultSort: "followUpDate",
        loadListenersCallback: IncidentToDoList.loadInvestigationListeners,
        getSortersDictCallback: IncidentToDoList.getSortersDict,
      },
      incidentFlaggedForNewEnforcement: {
        apiSubjectName: "incident-flagged-for-new-enforcement",
        databaseName: "incident_flagged_for_new_enforcement",
        displayName: "Flagged for New Enforcement",
        numberBubbleClass: "asset-action",
        prepareDataCallback: IncidentToDoList.organizeFlaggedForNewEnforcement,
        canAccessCallback: IncidentToDoList.canEnforceIncident,
        listTemplate: "list/toDoListTables/incidentFlaggedForNewEnforcement.njk",
        defaultSort: "name",
        getSortersDictCallback: IncidentToDoList.getSortersDict,
        loadListenersCallback: IncidentToDoList.loadFlaggedForEnforcementListeners,
      },
      incidentOpenEnforcement: {
        apiSubjectName: "incident-open-enforcement",
        databaseName: "incident_open_enforcement",
        displayName: "Open Enforcements",
        numberBubbleClass: "asset-action",
        prepareDataCallback: IncidentToDoList.organizeOpenEnforcements,
        canAccessCallback: IncidentToDoList.canEnforceIncident,
        listTemplate: "list/toDoListTables/incidentOpenEnforcement.njk",
        defaultSort: "issueDate",
        getSortersDictCallback: IncidentToDoList.getSortersDict,
        loadListenersCallback: IncidentToDoList.loadEnforcementListeners,
      },
      incidentRecommendedAction: {
        apiSubjectName: "incident-recommended-action",
        databaseName: "incident_recommended_action",
        displayName: "Flagged Open Enforcements",
        numberBubbleClass: "asset-action",
        prepareDataCallback: IncidentToDoList.organizeRecommendedAction,
        canAccessCallback: IncidentToDoList.canEnforceIncident,
        listTemplate: "list/toDoListTables/incidentFlaggedOpenEnforcement.njk",
        defaultSort: "issueDate",
        getSortersDictCallback: IncidentToDoList.getSortersDict,
        loadListenersCallback: IncidentToDoList.loadEnforcementListeners,
      },
      routineScreeningDryWeather: {
        apiSubjectName: "dry-weather-inspection",
        databaseName: "monitoring_location",
        displayName: "Routine Screening",
        numberBubbleClass: "asset-due",
        prepareDataCallback: DryWeatherToDoList.organizeRoutineScreening,
        canAccessCallback: DryWeatherToDoList.canAccessRoutineScreening,
        defaultSort: "dueDate",
        listTemplate: "list/toDoListTables/routineScreeningDryWeather.njk",
        getSortersDictCallback: DryWeatherToDoList.getSortersDict,
        loadListenersCallback: DryWeatherToDoList.loadScreeningListeners,
      },
      reScreeningDryWeather: {
        apiSubjectName: "dry-weather-re-screening",
        databaseName: "monitoring_location_re_screening",
        displayName: "Re-Screening Follow Up",
        numberBubbleClass: "asset-poor",
        prepareDataCallback: DryWeatherToDoList.organizeReScreening,
        canAccessCallback: DryWeatherToDoList.canAccessRoutineScreening,
        defaultSort: "dueDate",
        listTemplate: "list/toDoListTables/reScreeningDryWeather.njk",
        getSortersDictCallback: DryWeatherToDoList.getSortersDict,
        loadListenersCallback: DryWeatherToDoList.loadReScreeningListeners,
      },
      muniOutfallRoutineInspection: {
        apiSubjectName: "muni-outfall-routine-inspection",
        databaseName: "outfall_inspection",
        displayName: "Routine Inspection",
        numberBubbleClass: "asset-due",
        filterTemplate: "modals/toDoFilters/muniOutfallFiltersModal.njk",
        getFilterTemplateDataCallback: OutfallInspectionConstants.addInspectionToDoFilterOptions,
        prepareDataCallback: MuniOutfallToDoList.organizeMuniOutfallRoutineInspection,
        canAccessCallback: MuniOutfallToDoList.canAccessRoutineInspections,
        defaultSort: "dueDateIso",
        listTemplate: "list/toDoListTables/muniOutfallRoutineInspection.njk",
        getSortersDictCallback: MuniOutfallToDoList.getSortersDict,
      },
      muniOutfallRoutineMaintenance: {
        apiSubjectName: "muni-outfall-routine-maintenance",
        databaseName: "outfall_repair",
        displayName: "Routine Maintenance",
        numberBubbleClass: "asset-poor",
        filterTemplate: "modals/toDoFilters/muniOutfallFiltersModal.njk",
        getFilterTemplateDataCallback: OutfallInspectionConstants.addInspectionToDoFilterOptions,
        prepareDataCallback: MuniOutfallToDoList.organizeMuniOutfallRoutineMaintenance,
        canAccessCallback: MuniOutfallToDoList.canAccessRoutineInspections,
        defaultSort: "dueDateIso",
        listTemplate: "list/toDoListTables/muniOutfallRoutineMaintenance.njk",
        getSortersDictCallback: MuniOutfallToDoList.getSortersDict,
      },
      constructionCompleteProject: {
        displayName: "Complete Project Tasks",
        numberBubbleClass: "asset-due",
        apiSubjectName: "complete-project",
        databaseName: "construction_complete_project",
        listTemplate: "list/toDoListTables/constructionCompleteProject.njk",
        canAccessCallback: ConstructionToDoController.canShowCompleteProjectTodos,
        loadListenersCallback: ConstructionToDoController.loadToDoListeners,
        prepareDataCallback: ConstructionToDoController.organizeCompleteProjectTodos,
        getSortersDictCallback: ConstructionToDoController.getSortersDict,
      },
      constructionProjectOpenEnforcement: {
        apiSubjectName: "construction-open-enforcement",
        databaseName: "construction_open_enforcement",
        displayName: "Open Enforcements",
        prepareDataCallback: ConstructionToDoController.organizeOpenEnforcementTodos,
        numberBubbleClass: "asset-action",
        listTemplate: "list/toDoListTables/constructionProjectOpenEnforcement.njk",
        defaultSort: "issueDate",
        canAccessCallback: ConstructionToDoController.canShowProjectEnforcementActionsTodos,
        getSortersDictCallback: ConstructionToDoController.getSortersDict,
      },
      constructionProjectFlaggedForNewEnforcement: {
        apiSubjectName: "flagged-for-new-enforcement",
        databaseName: "construction_flagged_for_new_enforcement",
        displayName: "Flagged for New Enforcement",
        prepareDataCallback: ConstructionToDoController.organizeFlaggedForNewEnforcementTodos,
        numberBubbleClass: "asset-action",
        listTemplate: "list/toDoListTables/constructionProjectFlaggedForNewEnforcement.njk",
        defaultSort: "projectIdentifier",
        canAccessCallback: ConstructionToDoController.canShowProjectEnforcementActionsTodos,
        loadListenersCallback: ConstructionToDoController.loadToDoListeners,
        getSortersDictCallback: ConstructionToDoController.getSortersDict,
      },
      constructionProjectFlaggedForEnforcementRecommendedAction: {
        apiSubjectName: "recommended-action",
        databaseName: "construction_recommended_action",
        displayName: "Flagged Open Enforcements",
        prepareDataCallback: ConstructionToDoController.organizeRecommendedActionTodos,
        numberBubbleClass: "asset-action",
        listTemplate:
          "list/toDoListTables/constructionProjectFlaggedForEnforcementRecommendedAction.njk",
        defaultSort: "issueDate",
        canAccessCallback: ConstructionToDoController.canShowProjectEnforcementActionsTodos,
        getSortersDictCallback: ConstructionToDoController.getSortersDict,
      },
      constructionProjectRoutineInspection: {
        apiSubjectName: "routine-inspection",
        databaseName: "construction_routine_inspection",
        displayName: "Routine Inspections",
        numberBubbleClass: "asset-due",
        listTemplate: "list/toDoListTables/constructionProjectRoutineInspection.njk",
        defaultSort: "dueDate",
        canAccessCallback: ConstructionToDoController.canShowProjectInspectionTodos,
        prepareDataCallback: ConstructionToDoController.organizeRoutineInspectionTodos,
        getSortersDictCallback: ConstructionToDoController.getSortersDict,
      },
      constructionProjectReInspection: {
        apiSubjectName: "re-inspection",
        databaseName: "construction_re_inspection",
        displayName: "Re-Inspections",
        numberBubbleClass: "asset-poor",
        listTemplate: "list/toDoListTables/constructionProjectReInspection.njk",
        defaultSort: "dueDate",
        canAccessCallback: ConstructionToDoController.canShowProjectInspectionTodos,
        prepareDataCallback: ConstructionToDoController.organizeReInspectionTodos,
        getSortersDictCallback: ConstructionToDoController.getSortersDict,
      },
      constructionProjectMaintenanceResponse: {
        apiSubjectName: "construction-maintenance-response",
        databaseName: "construction_maintenance_response",
        displayName: "Awaiting Maintenance Responses",
        numberBubbleClass: "asset-poor",
        listTemplate: "list/toDoListTables/constructionProjectMaintenanceResponse.njk",
        defaultSort: "dueDate",
        canAccessCallback: ConstructionToDoController.canShowProjectInspectionTodos,
        prepareDataCallback: ConstructionToDoController.organizeMaintenanceResponseTodos,
        getSortersDictCallback: ConstructionToDoController.getSortersDict,
      },
      constructionInstallationInspection: {
        displayName: "Structural BMP Installation Tasks",
        numberBubbleClass: "asset-incomplete",
        apiSubjectName: "installation-inspection",
        databaseName: "construction_installation_inspection",
        listTemplate: "list/toDoListTables/constructionInstallationInspection.njk",
        canAccessCallback: ConstructionToDoController.canShowBmpInstallationTodos,
        prepareDataCallback: ConstructionToDoController.organizeInstallationInspectionTodos,
        getSortersDictCallback: ConstructionToDoController.getSortersDict,
      },
      lidMissingInformation: {
        apiSubjectName: "lid-missing-information",
        databaseName: "lid_missing_information",
        displayName: "Missing Information",
        prepareDataCallback: LidToDoList.organizeMissingInformation,
        canAccessCallback: LidToDoList.canInventory,
        numberBubbleClass: "asset-incomplete",
        listTemplate: "list/lidProjectMissingInformationToDoList.njk",
        loadListenersCallback: LidToDoList.loadMissingInformationListeners,
        getSortersDictCallback: LidToDoList.getSortersDict,
      },
      lidProjectEnforcement: {
        apiSubjectName: "lid-open-enforcements",
        databaseName: "lid_open_enforcement",
        displayName: "Open Enforcements",
        prepareDataCallback: LidToDoList.organizeProjectEnforcements,
        canAccessCallback: LidToDoList.canEnforceProject,
        numberBubbleClass: "asset-action",
        listTemplate: "list/toDoListTables/lidProjectEnforcement.njk",
        defaultSort: "issueDate",
        getSortersDictCallback: LidToDoList.getSortersDict,
      },
      lidProjectFlaggedForNewEnforcement: {
        apiSubjectName: "lid-flagged-for-new-enforcement",
        databaseName: "lid_flagged_for_new_enforcement",
        displayName: "Flagged for New Enforcement",
        prepareDataCallback: LidToDoList.organizeFlaggedForNewEnforcementTodos,
        numberBubbleClass: "asset-action",
        listTemplate: "list/toDoListTables/lidProjectFlaggedForNewEnforcement.njk",
        defaultSort: "projectIdentifier",
        canAccessCallback: LidToDoList.canEnforceProject,
        getSortersDictCallback: LidToDoList.getSortersDict,
        loadListenersCallback: LidToDoList.loadFlaggedForEnforcementListeners,
      },
      lidProjectRecommendedAction: {
        apiSubjectName: "lid-recommended-action",
        databaseName: "lid_recommended_action",
        displayName: "Flagged Open Enforcements",
        prepareDataCallback: LidToDoList.organizeRecommendedActionTodos,
        numberBubbleClass: "asset-action",
        listTemplate: "list/toDoListTables/lidProjectRecommendedAction.njk",
        defaultSort: "issueDate",
        canAccessCallback: LidToDoList.canEnforceProject,
        getSortersDictCallback: LidToDoList.getSortersDict,
      },
      lidMaintenanceNotice: {
        apiSubjectName: "lid-maintenance-notice",
        databaseName: "lid_maintenance_notice",
        displayName: "Generate Maintenance Notices",
        prepareDataCallback: LidToDoList.organizeMaintenanceNotices,
        canAccessCallback: ConstructionToDoController.canShowProjectInspectionTodos,
        numberBubbleClass: "asset-due",
        listTemplate: "list/lidProjectMaintenanceNoticeToDoList.njk",
        loadListenersCallback: LidToDoList.loadFormalCommunicationsListeners,
        getSortersDictCallback: LidToDoList.getSortersDict,
        defaultSort: "dueDate",
      },
      lidInspection: {
        apiSubjectName: "lid-inspection",
        databaseName: "lid_inspection",
        displayName: "Routine Inspections",
        prepareDataCallback: LidToDoList.organizeInspections,
        canAccessCallback: ConstructionToDoController.canShowProjectInspectionTodos,
        numberBubbleClass: "asset-due",
        listTemplate: "list/lidProjectInspectionToDoList.njk",
        loadListenersCallback: LidToDoList.loadInspectionListeners,
        getSortersDictCallback: LidToDoList.getSortersDict,
        defaultSort: "bmpInspectionProgressPercentage",
      },
      lidMaintenanceResponse: {
        apiSubjectName: "lid-maintenance-response",
        databaseName: "lid_maintenance_response",
        displayName: "Awaiting Maintenance Responses",
        prepareDataCallback: LidToDoList.organizeMaintenanceResponses,
        canAccessCallback: ConstructionToDoController.canShowProjectInspectionTodos,
        numberBubbleClass: "asset-poor",
        listTemplate: "list/lidProjectMaintenanceResponseToDoList.njk",
        loadListenersCallback: LidToDoList.loadMaintenanceResponseListeners,
        getSortersDictCallback: LidToDoList.getSortersDict,
        defaultSort: "dueDate",
      },
      lidReInspection: {
        apiSubjectName: "lid-re-inspection",
        databaseName: "lid_re_inspection",
        displayName: "Re-Inspections",
        prepareDataCallback: LidToDoList.organizeReInspections,
        canAccessCallback: ConstructionToDoController.canShowProjectInspectionTodos,
        numberBubbleClass: "asset-poor",
        listTemplate: "list/lidProjectReInspectionToDoList.njk",
        loadListenersCallback: LidToDoList.loadReInspectionListeners,
        getSortersDictCallback: LidToDoList.getSortersDict,
        defaultSort: "bmpInspectionProgressPercentage",
      },
      lidReviewResponse: {
        apiSubjectName: "lid-review-response",
        databaseName: "lid_review_response",
        displayName: "Review Maintenance Responses",
        prepareDataCallback: LidToDoList.organizeReviewResponses,
        canAccessCallback: (user) =>
          ConstructionToDoController.canShowProjectInspectionTodos(user) &&
          ToolSettings.getSetting("group", "portalSubscriberTools")?.includes("lid"),
        numberBubbleClass: "asset-poor",
        listTemplate: "list/lidProjectReviewResponseToDoList.njk",
        loadListenersCallback: LidToDoList.loadReviewResponseListeners,
        getSortersDictCallback: LidToDoList.getSortersDict,
        defaultSort: "dueDate",
      },
      indcomFacilityInspection: {
        apiSubjectName: "inspection",
        databaseName: "indcom_facility_inspection",
        displayName: "Routine Inspections",
        prepareDataCallback: IndcomToDoList.organizeFacilityInspections,
        canAccessCallback: IndcomToDoList.canInspectFacility,
        numberBubbleClass: "asset-due",
        listTemplate: "list/toDoListTables/indcomFacilityInspection.njk",
        defaultSort: "dueDate",
        getSortersDictCallback: IndcomToDoList.getSortersDict,
        loadListenersCallback: IndcomToDoList.loadListeners,
      },
      indcomFacilityReinspection: {
        apiSubjectName: "reinspection",
        databaseName: "indcom_facility_reinspection",
        displayName: "Re-Inspections",
        prepareDataCallback: IndcomToDoList.organizeFacilityReinspection,
        canAccessCallback: IndcomToDoList.canInspectFacility,
        numberBubbleClass: "asset-poor",
        listTemplate: "list/toDoListTables/indcomFacilityReinspection.njk",
        defaultSort: "dueDate",
        getSortersDictCallback: IndcomToDoList.getSortersDict,
        loadListenersCallback: IndcomToDoList.loadListeners,
      },
      indcomFacilityMaintenanceResponse: {
        apiSubjectName: "indcom-maintenance-response",
        databaseName: "indcom_facility_maintenance_response",
        displayName: "Awaiting Maintenance Responses",
        prepareDataCallback: IndcomToDoList.organizeFacilityMaintenanceResponse,
        canAccessCallback: IndcomToDoList.canInspectFacility,
        numberBubbleClass: "asset-poor",
        listTemplate: "list/toDoListTables/indcomFacilityMaintenanceResponse.njk",
        defaultSort: "dueDate",
        getSortersDictCallback: IndcomToDoList.getSortersDict,
        loadListenersCallback: IndcomToDoList.loadListeners,
      },
      indcomFacilityReviewResponse: {
        apiSubjectName: "review-response",
        databaseName: "indcom_facility_review_response",
        displayName: "Review Maintenance Responses",
        prepareDataCallback: IndcomToDoList.organizeFacilityReviewResponse,
        canAccessCallback: IndcomToDoList.canReviewFacility,
        numberBubbleClass: "asset-poor",
        listTemplate: "list/toDoListTables/indcomFacilityReviewResponse.njk",
        defaultSort: "dueDate",
        getSortersDictCallback: IndcomToDoList.getSortersDict,
        loadListenersCallback: IndcomToDoList.loadListeners,
      },
      indcomFacilityFlaggedForNewEnforcement: {
        apiSubjectName: "indcom-flagged-for-new-enforcement",
        databaseName: "indcom_facility_flagged_enforcement",
        displayName: "Flagged for New Enforcement",
        numberBubbleClass: "asset-action",
        listTemplate: "list/toDoListTables/indcomFacilityFlaggedForNewEnforcement.njk",
        defaultSort: "facilityIdentifier",
        prepareDataCallback: IndcomToDoList.organizeFacilityFlaggedForNewEnforcement,
        canAccessCallback: IndcomToDoList.canEnforceFacility,
        loadListenersCallback: IndcomToDoList.loadFlaggedForEnforcementListeners,
        getSortersDictCallback: IndcomToDoList.getSortersDict,
      },
      indcomFacilityRecommendedAction: {
        apiSubjectName: "indcom-recommended-action",
        databaseName: "indcom_facility_recommended_action",
        displayName: "Flagged Open Enforcements",
        prepareDataCallback: IndcomToDoList.organizeFacilityRecommendedAction,
        numberBubbleClass: "asset-action",
        listTemplate: "list/toDoListTables/indcomFacilityRecommendedAction.njk",
        defaultSort: "facilityIdentifier",
        canAccessCallback: IndcomToDoList.canEnforceFacility,
        loadListenersCallback: IndcomToDoList.loadListeners,
        getSortersDictCallback: IndcomToDoList.getSortersDict,
      },
      indcomFacilityEnforcement: {
        apiSubjectName: "indcom-open-enforcement",
        databaseName: "indcom_facility_enforcement",
        displayName: "Open Enforcements",
        prepareDataCallback: IndcomToDoList.organizeFacilityEnforcements,
        canAccessCallback: IndcomToDoList.canEnforceFacility,
        numberBubbleClass: "asset-action",
        listTemplate: "list/toDoListTables/indcomFacilityEnforcement.njk",
        defaultSort: "issueDate",
        getSortersDictCallback: IndcomToDoList.getSortersDict,
        loadListenersCallback: IndcomToDoList.loadListeners,
      },
      indcomFacilityInventoryIncomplete: {
        apiSubjectName: "inventory-incomplete",
        databaseName: "indcom_facility_inventory_incomplete",
        displayName: "Missing Information",
        prepareDataCallback: IndcomToDoList.organizeFacilityInventoryIncomplete,
        canAccessCallback: IndcomToDoList.canEditFacility,
        numberBubbleClass: "asset-incomplete",
        listTemplate: "list/toDoListTables/indcomFacilityInventoryIncomplete.njk",
        defaultSort: "name",
        getSortersDictCallback: IndcomToDoList.getSortersDict,
        loadListenersCallback: IndcomToDoList.loadListeners,
      },
    };
  };

  const getToDoConfigObjectByDataView = function () {
    return {
      "construction-project": {
        genericFactSheet: {
          initFactSheet: (id, highlightId = null) =>
            highlightId
              ? UrlRoutes.go("construction-project-fact-sheet-highlight", { id, highlightId })
              : UrlRoutes.go("construction-project-fact-sheet", { id }),
        },
      },
      bmp: {
        genericFactSheet: {
          initFactSheet: (id, highlightId = null) =>
            highlightId
              ? UrlRoutes.go("sbmp-fact-sheet-highlight", { id, highlightId })
              : UrlRoutes.go("sbmp-fact-sheet", { id }),
        },
      },
      "muni-bmp": {
        genericFactSheet: {
          initFactSheet: (id, highlightId = null) =>
            highlightId
              ? UrlRoutes.go("muni-bmp-sheet-highlight", { id, highlightId })
              : UrlRoutes.go("muni-bmp-fact-sheet", { id }),
        },
      },
      "lid-bmp": {
        genericFactSheet: {
          initFactSheet: (id, highlightId = null) =>
            highlightId
              ? UrlRoutes.go("lid-bmp-fact-sheet-highlight", { id, highlightId })
              : UrlRoutes.go("lid-bmp-fact-sheet", { id }),
        },
      },
      fcs: {
        genericFactSheet: false,
      },
      incidents: {
        genericFactSheet: false,
      },
      "dry-weather": {
        genericFactSheet: {
          initFactSheet: (id, highlightId = null) => UrlRoutes.go("idde-fact-sheet", { id }),
        },
      },
      "muni-catch-basin": {
        genericFactSheet: {
          initFactSheet: (id, highlightId = null) =>
            highlightId
              ? UrlRoutes.go("catch-basin-fact-sheet-highlight", { id, highlightId })
              : UrlRoutes.go("catch-basin-fact-sheet", { id }),
        },
      },
      "muni-outfalls": {
        genericFactSheet: {
          initFactSheet: (id, highlightId = null) =>
            highlightId
              ? UrlRoutes.go("outfall-fact-sheet-highlight", { id, highlightId })
              : UrlRoutes.go("outfall-fact-sheet", { id }),
        },
      },
      "indcom-facilities": {
        genericFactSheet: {
          initFactSheet: (id, highlightId = null) =>
            highlightId
              ? UrlRoutes.go("facility-fact-sheet-highlight", { id, highlightId })
              : UrlRoutes.go("facility-fact-sheet", { id }),
        },
      },
      "lid-project": {
        genericFactSheet: {
          initFactSheet: (id, highlightId = null) =>
            highlightId
              ? UrlRoutes.go("lid-fact-sheet-highlight", { id, highlightId })
              : UrlRoutes.go("lid-fact-sheet", { id }),
        },
      },
    };
  };

  const _getToDoFiltersConfigObjectByDataView = function () {
    return {
      incidents: {
        filters: {
          incidentNew: {
            get requestingType() {
              return IncidentInventoryConstants.getRequestingTypeOptions().map(
                (options) => options.value,
              );
            },
            requestingAffiliation: [
              "general-public",
              "partner-agency",
              "dot-staff",
              "ms4-staff",
              "local-agency",
            ],
            requestedDateFrom: null,
            requestedDateTo: null,
          },
          incidentOpen: {
            get requestingType() {
              return IncidentInventoryConstants.getRequestingTypeOptions().map(
                (options) => options.value,
              );
            },
            incidentType: ["illicit-flow", "spill", "illegal-dumping", "unknown"],
            responsiblePartyIdentified: ["true", "false", "unknown"],
            requestingAffiliation: [
              "general-public",
              "partner-agency",
              "dot-staff",
              "ms4-staff",
              "local-agency",
            ],
            requestedDateFrom: null,
            requestedDateTo: null,
          },
        },
        filterDataTypes: {
          requestedDate: "dateRange",
        },
      },
      "muni-catch-basin": {
        filters: {
          routineSiteVisit: {
            consequenceOfFailure: ["very-high", "high", "moderate", "low", "very-low", "unknown"],
            catchBasinPriority: ["high", "medium", "low", "unknown"],
            inProximityTo303dWaterbody: ["true", "false", "unknown"],
            dueDateFrom: null,
            dueDateTo: null,
            allSpatial: true,
          },
          routineRepair: {
            consequenceOfFailure: ["very-high", "high", "moderate", "low", "very-low", "unknown"],
            catchBasinPriority: ["high", "medium", "low", "unknown"],
            correctiveAction: MuniBmpFilters.getCatchBasinCorrectiveActions().map(
              (task) => task.value,
            ),
            enforcementLevel: [
              "minimal-issue",
              "minor-issue",
              "major-issue",
              "replacement-required",
              "clean",
              "unknown",
            ],
            dueDateFrom: null,
            dueDateTo: null,
            allSpatial: true,
          },
          catchBasinInventoryIncomplete: {
            allSpatial: true,
          },
        },
        filterDataTypes: {
          dueDate: "dateRange",
        },
      },
      "muni-outfalls": {
        filters: {
          muniOutfallRoutineInspection: {
            dueDateFrom: null,
            dueDateTo: null,
            implementerType: [
              "partner",
              "private",
              "our-agency",
              "dot",
              "ms4",
              "local-agency",
              "other",
              "unknown",
            ],
            maintainerType: [
              "partner",
              "private",
              "our-agency",
              "dot",
              "ms4",
              "local-agency",
              "other",
              "unknown",
            ],
            outletType: [
              "apron",
              "ditch-outlet",
              "earthen",
              "flap-gate",
              "pipe",
              "slotted",
              "tide-chamber",
              "unknown",
              "weir",
              "rundown",
              "other",
              "flared",
              "riser",
              "endwall",
            ],
            priority: ["true", "false"],
            consequenceOfFailure: ["very-high", "high", "moderate", "low", "very-low", "unknown"],
          },
          muniOutfallRoutineMaintenance: {
            dueDateFrom: null,
            dueDateTo: null,
            implementerType: [
              "partner",
              "private",
              "our-agency",
              "dot",
              "ms4",
              "local-agency",
              "other",
              "unknown",
            ],
            maintainerType: [
              "partner",
              "private",
              "our-agency",
              "dot",
              "ms4",
              "local-agency",
              "other",
              "unknown",
            ],
            outletType: [
              "apron",
              "ditch-outlet",
              "earthen",
              "flap-gate",
              "pipe",
              "slotted",
              "tide-chamber",
              "unknown",
              "weir",
              "rundown",
              "other",
              "flared",
              "riser",
              "endwall",
            ],
            priority: ["true", "false"],
            consequenceOfFailure: ["very-high", "high", "moderate", "low", "very-low", "unknown"],
          },
        },
        filterDataTypes: {
          dueDate: "dateRange",
        },
      },
    };
  };

  var getAllToDoDataViewConfigsByProperty = function (property) {
    const configsByDataView = _getToDoFiltersConfigObjectByDataView();
    var result = {};

    for (const dataView in configsByDataView) {
      const configProperty = configsByDataView[dataView][property];

      if (configProperty !== undefined) {
        result[dataView] = configProperty;
      }
    }

    return result;
  };

  var getToDoDataViewConfig = function (pathArray, throwOnUndefined = true) {
    var config = getToDoConfigObjectByDataView();

    for (const pathPart of pathArray) {
      config = config ? config[pathPart] : undefined;

      if (config === undefined && throwOnUndefined) {
        throw new Error(`No to do data view property configured for [${pathArray.join(", ")}].`);
      }
    }

    return config;
  };

  var getToDoFiltersDataViewConfig = function (pathArray, throwOnUndefined = true) {
    var config = _getToDoFiltersConfigObjectByDataView();

    for (const pathPart of pathArray) {
      config = config ? config[pathPart] : undefined;

      if (config === undefined && throwOnUndefined) {
        throw new Error(`No to do data view property configured for [${pathArray.join(", ")}].`);
      }
    }

    return config;
  };

  var getToDoSubjectConfig = function (pathArray, throwOnUndefined = true) {
    var config = getToDoConfigBySubject();

    for (const pathPart of pathArray) {
      config = config ? config[pathPart] : undefined;

      if (config === undefined && throwOnUndefined) {
        throw new Error(`No to do subject property configured for [${pathArray.join(", ")}].`);
      }
    }

    return config;
  };

  return {
    getAllToDoDataViewConfigsByProperty,
    getToDoSubjectConfig,
    getToDoDataViewConfig,
    getToDoFiltersDataViewConfig,
    _getToDoFiltersConfigObjectByDataView,
  };
};

module.exports = ToDoConfig();

const BmpFcsToDoController = require("../bmpfcs/bmpFcsToDoController");
const IncidentInventoryConstants = require("../illicitDischarge/incidents/incidentInventoryConstants");
const IncidentInvestigationConstants = require("../illicitDischarge/incidentInvestigation/incidentInvestigationConstants");
const MuniBmpFilters = require("../muni/bmp/muniBmpFilters");
const MuniOutfallToDoList = require("../muni/outfalls/muniOutfallToDoList");
const OutfallInspectionConstants = require("../outfalls/outfallInspectionConstants");
const LidToDoList = require("../lid/lidToDoList");
const ConstructionToDoController = require("../construction/constructionToDoController");
const ToolSettings = require("../settings/toolSettings");
const UrlRoutes = require("../routes/urlRoutes.js");
const ToDoPrioritizeController = require("../muni/catchBasinToDoPrioritize/toDoPrioritizeController.js");
const IndcomToDoList = require("../indcom/indcomToDoList");
const UserPermissions = require("../login/userPermissions.js");
const IncidentToDoList = require("../illicitDischarge/incidents/incidentToDoList");
const DryWeatherToDoList = require("../illicitDischarge/dryWeatherScreening/dryWeatherToDoList");
